import { skipToken } from "@apollo/client";
import { useSuspenseQueryHandler } from "@sinch/hooks/useSuspenseQueryHandler";
import type { RatelistType } from "@sinch/types/sinch.types";
import { ConditionCategories } from "./queries.graphql";
import type { ConditionCategoriesQuery, ConditionCategoriesQueryVariables } from "./queries.types";
import { ConditionCategory } from "@sinch/core/entities/serverEnums.types";

/**
 * Loads rate condition categories for the given ratelist type. Skips fetching when ratelistType is null.
 */
export const useConditionCategories = (ratelistType: RatelistType | null | undefined) => {
  const { data } = useSuspenseQueryHandler<ConditionCategoriesQuery, ConditionCategoriesQueryVariables>(
    ConditionCategories,
    ratelistType ? { ratelistType } : undefined,
    ratelistType ? {} : skipToken
  );

  const getLabel = (categoryVal: ConditionCategory) => data?.rateConditionCategories.find(({ category }) => categoryVal === category)?.label ?? null;

  return { rateConditionCategories: data?.rateConditionCategories ?? null, getLabel };
};
